import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { Grid, Dialog, Button, SubmitButton, DatePicker, SearchSelect } from "../../../../../";
import { makeStyles } from "@material-ui/styles";
import { TextField } from "formik-material-ui";
import { Debug } from "../../../../../Molecules/Forms/Debug";
var campusSchema = Yup.object().shape({
  name: Yup.string().required("Campo obligatorio"),
  date: Yup.object().shape({
    start: Yup.string().required(),
    end: Yup.string().min(1).required()
  }),
  targetUsers: Yup.number().min(1).required(),
  project: Yup.string()
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      "justify-content": "flex-end"
    },
    flex: {
      display: "flex"
    }
  };
});

var DialogCampusSingleEditCampus = function DialogCampusSingleEditCampus(props) {
  var initialValues = props.data || {
    name: "",
    date: {
      start: null,
      end: null
    },
    targetUsers: null,
    project: null
  };
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: props.translation ? props.translation.title || "Edit Campus" : "Edit Campus",
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: campusSchema,
    onSubmit: function onSubmit(values) {
      if (initialValues.project !== values.project) {
        values.projectChange = true;
      } else {
        values.projectChange = false;
      }

      props.onSubmit(values);
      props.onClose();
    },
    render: function render(_ref) {
      var isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        component: TextField,
        label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
        name: "name",
        variant: "outlined",
        fullWidth: true,
        margin: "normal"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/React.createElement(Field, {
        component: DatePicker,
        label: props.translation ? props.translation.inputs ? props.translation.inputs.date_start || "Date Start" : "Date Start" : "Date Start",
        name: "date.start",
        fullWidth: true,
        margin: "normal"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/React.createElement(Field, {
        component: DatePicker,
        label: props.translation ? props.translation.inputs ? props.translation.inputs.date_end || "Date End" : "Date End" : "Date End",
        name: "date.end",
        variant: "outlined",
        fullWidth: true,
        margin: "normal"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/React.createElement(Field, {
        component: TextField,
        type: "number",
        label: props.translation ? props.translation.inputs ? props.translation.inputs.target_users || "Target Users" : "Target Users" : "Target Users",
        name: "targetUsers",
        variant: "outlined",
        fullWidth: true,
        margin: "normal"
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, props.translation ? props.translation.buttons ? props.translation.buttons.save || "Save" : "Save" : "Save")));
    }
  }));
};

export { DialogCampusSingleEditCampus };